import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { UserMenuOpenToggleCtx } from '../UserMenuV2';

export default ({ link, iconCls, label, openNewTab, onClick }) => {
  const { toggleOpen } = useContext(UserMenuOpenToggleCtx);

  const clickHandler = () => {
    onClick && onClick();
    toggleOpen && toggleOpen();
  };

  if (!link || link.startsWith('http')) {
    return (
      <li onClick={clickHandler}>
        <a href={link} target={openNewTab ? '_blank' : '_self'}>
          <i className={iconCls} />
          <span className="half-spacing-left">{label}</span>
        </a>
      </li>
    );
  }

  return (
    <li onClick={clickHandler}>
      <Link to={link}>
        <i className={iconCls} />
        <span className="half-spacing-left">{label}</span>
      </Link>
    </li>
  );
};
